import { z } from 'zod';

import type { UploadedFile } from './types';

/**
 * An uploaded asset as returned by the product detail endpoints (device/component/bundle
 * `images[]` and `installationGuides[]`). The backend keys uploads by `assetId`; the FE
 * submits those ids back verbatim in `imageAssetIds` / `installationGuideAssetIds`.
 * Metadata fields are nullable (the backend may not populate them).
 */
export const productAssetSchema = z.object({
  assetId: z.string(),
  url: z.string(),
  originalFileName: z.string().nullish(),
  contentType: z.string().nullish(),
  size: z.number().nullish(),
});

export type ProductAsset = z.infer<typeof productAssetSchema>;

/** A detail asset → an UploadedFile the upload zones seed from. `id` is the `assetId`
 *  (round-trips into the create/update body); `url` is the real displayable link. */
export function assetToUploadedFile(asset: ProductAsset): UploadedFile {
  const basename = asset.url.split('/').pop()?.split('?')[0];
  return {
    id: asset.assetId,
    url: asset.url,
    name: asset.originalFileName ?? basename ?? asset.assetId,
    size: asset.size ?? 0,
    contentType: asset.contentType ?? '',
  };
}
